import { tokens } from '../../tokens';

interface Props {
  number: string;
  label: string;
  /** Lead section: green colored rule + bold number/label. */
  accent?: boolean;
}

const EditorialHeader = ({ number, label, accent }: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      paddingTop: 12,
      paddingBottom: 12,
      marginBottom: 24,
    }}
  >
    <span
      style={{
        fontSize: 14,
        fontFamily: tokens.fontMono,
        color: accent ? tokens.green : tokens.textTertiary,
        letterSpacing: '0.1em',
        lineHeight: 1,
        fontWeight: accent ? 700 : undefined,
      }}
    >
      {number}
    </span>
    <div
      style={{
        flex: 1,
        borderTop: accent
          ? `2px solid ${tokens.green}`
          : '1px solid rgba(255,255,255,0.4)',
      }}
    />
    <span
      style={{
        fontSize: 11,
        color: accent ? tokens.green : tokens.textTertiary,
        textTransform: 'uppercase',
        letterSpacing: '0.2em',
        lineHeight: 1,
        fontWeight: accent ? 700 : undefined,
      }}
    >
      {label}
    </span>
  </div>
);

export default EditorialHeader;
